export function rotateArrayToFirst(array, finder) {
    const index = array.findIndex(finder);
    if (index === -1) {
        throw new Error('Item not found in array');
    }
    return [...array.slice(index), ...array.slice(0, index)];
}
